// Private guided tour templates for each city
export const privateTours = {
  // LISBON PRIVATE TOUR
  lisbon: {
    id: 'lisbon-premium',
    city: 'Lisbon',
    label: 'Premium Lisbon Discovery Tour',
    duration: '8 hours',
    price: 'From €295',
    groupSize: '2-6 people',
    rating: 4.9,
    reviewCount: 187,
    category: 'Cultural Experience',
    description: 'Immerse yourself in Lisbon\'s rich history and vibrant culture with our exclusive full-day private tour. Enjoy skip-the-line access to major attractions, personalized attention from your expert local guide, and a carefully curated itinerary that showcases the very best of Portugal\'s captivating capital.',
    highlights: [
      'Skip-the-line access to Jerónimos Monastery and Belém Tower',
      'Exclusive tasting of Pastéis de Belém at their birthplace',
      'Private tram ride through Alfama\'s picturesque streets',
      'Guided tour of São Jorge Castle with panoramic city views',
      'Authentic Portuguese lunch at a hidden local gem',
      'Personalized recommendations for the rest of your stay'
    ],
    detailedItinerary: [
      {
        time: '09:00',
        title: 'Hotel Pickup & Belém District',
        description: 'Your private guide will meet you at your accommodation. We\'ll start with a scenic drive to Belém, where we\'ll visit the iconic Belém Tower and the stunning Jerónimos Monastery (with skip-the-line access). Enjoy a tasting of the famous Pastéis de Belém at the original bakery.',
        pois: [
          {
            name: 'Jerónimos Monastery',
            duration: '45 min',
            highlight: 'UNESCO World Heritage Site with stunning Manueline architecture',
            lat: 38.6979,
            lng: -9.2066
          },
          {
            name: 'Belém Tower',
            duration: '30 min',
            highlight: '16th-century fortress and symbol of Portugal\'s Age of Discovery',
            lat: 38.6916,
            lng: -9.2160
          },
          {
            name: 'Pastéis de Belém',
            duration: '20 min',
            highlight: 'Taste the original recipe custard tarts',
            lat: 38.6979,
            lng: -9.2032
          }
        ]
      },
      {
        time: '12:30',
        title: 'Riverside Lunch',
        description: 'Enjoy a delicious lunch at a carefully selected local restaurant with stunning views of the Tagus River. Sample traditional Portuguese dishes like bacalhau à brás (salted cod) and grilled sardines, paired with excellent local wines.',
        pois: [
          {
            name: 'Riverside Restaurant',
            duration: '1.5 hours',
            highlight: 'Authentic Portuguese cuisine with river views'
          }
        ]
      },
      {
        time: '14:00',
        title: 'Alfama & São Jorge Castle',
        description: 'Explore the historic Alfama district, Lisbon\'s oldest neighborhood, with its narrow streets and traditional Fado houses. Take a private tram ride (included) and enjoy skip-the-line access to São Jorge Castle for breathtaking 360° views of the city.',
        pois: [
          {
            name: 'Alfama District',
            duration: '1 hour',
            highlight: 'Lisbon\'s most picturesque neighborhood',
            lat: 38.7105,
            lng: -9.1316
          },
          {
            name: 'São Jorge Castle',
            duration: '1 hour',
            highlight: 'Hilltop castle with panoramic views and peacocks',
            lat: 38.7139,
            lng: -9.1335
          }
        ]
      },
      {
        time: '16:30',
        title: 'Baixa & Chiado',
        description: 'Discover Lisbon\'s elegant downtown area, including the grand Commerce Square and the historic Santa Justa Elevator. Your guide will share fascinating stories about the city\'s reconstruction after the 1755 earthquake.',
        pois: [
          {
            name: 'Commerce Square',
            duration: '30 min',
            highlight: 'Grand plaza opening to the Tagus River',
            lat: 38.7076,
            lng: -9.1365
          },
          {
            name: 'Santa Justa Elevator',
            duration: '20 min',
            highlight: 'Neo-Gothic elevator with stunning city views',
            lat: 38.7115,
            lng: -9.1393
          }
        ]
      },
      {
        time: '17:30',
        title: 'Drop-off & Farewell',
        description: 'Your guide will take you back to your hotel or drop you at a recommended location for dinner, with personalized recommendations for the rest of your stay in Lisbon.'
      }
    ],
    includes: [
      'Private professional guide (fluent in English, Spanish, or Portuguese)',
      'Hotel pickup and drop-off in central Lisbon',
      'Skip-the-line tickets to all attractions',
      'Private transportation in a comfortable, air-conditioned vehicle',
      'Tram ride in Alfama',
      'Pastéis de Belém tasting',
      'Bottled water and Wi-Fi in the vehicle',
      'All taxes and fees'
    ],
    excludes: [
      'Lunch (budget approximately €25-35 per person)',
      'Personal expenses',
      'Gratuities (optional)'
    ],
    meetingPoint: 'Your hotel or accommodation in central Lisbon',
    cancellationPolicy: 'Free cancellation up to 48 hours before the tour for a full refund. No-shows or cancellations within 48 hours will be charged the full price.',
    additionalInfo: [
      'This tour involves moderate walking, comfortable shoes are recommended',
      'The tour operates in all weather conditions, please dress appropriately',
      'Infant seats available upon request',
      'Wheelchair accessible (please advise at time of booking)',
      'Private tour - only your group will participate'
    ]
  },

  // PORTO PRIVATE TOUR
  porto: {
    id: 'porto-premium',
    city: 'Porto',
    label: 'Exclusive Porto Wine & History Experience',
    duration: '8 hours',
    price: 'From €285',
    groupSize: '2-6 people',
    rating: 4.8,
    reviewCount: 142,
    category: 'Wine & Cultural Experience',
    description: 'Immerse yourself in the rich history and world-famous wine culture of Porto on this exclusive private tour. From the charming Ribeira district to the renowned Port wine cellars, experience the best of Portugal\'s second city with a knowledgeable local guide.',
    highlights: [
      'Skip-the-line access to Livraria Lello (inspiration for Harry Potter)',
      'Exclusive private tasting at a premium Port wine cellar',
      'Scenic 6-bridge Douro River cruise with welcome drink',
      'Guided tour of historic Ribeira District (UNESCO World Heritage)',
      'Traditional Portuguese lunch with river views',
      'Visit to the iconic Clérigos Tower',
      'Personalized attention from your private guide'
    ],
    detailedItinerary: [
      {
        time: '09:00',
        title: 'Hotel Pickup & Historic Center',
        description: 'Your private guide will meet you at your accommodation. We\'ll start with a visit to the magnificent Clérigos Tower for panoramic city views, followed by a guided tour of the stunning Livraria Lello, one of the most beautiful bookstores in the world and inspiration for the Harry Potter series.',
        pois: [
          {
            name: 'Clérigos Tower',
            duration: '45 min',
            highlight: 'Iconic baroque tower with panoramic city views'
          },
          {
            name: 'Livraria Lello',
            duration: '40 min',
            highlight: 'Stunning neo-Gothic bookstore that inspired J.K. Rowling'
          }
        ]
      },
      {
        time: '11:00',
        title: 'Ribeira District',
        description: 'Stroll through the colorful streets of Ribeira, Porto\'s historic riverside district (UNESCO World Heritage). Learn about the city\'s rich history, see traditional rabelo boats, and capture stunning photos of the iconic Dom Luís I Bridge.',
        pois: [
          {
            name: 'Ribeira Square',
            duration: '1 hour',
            highlight: 'Vibrant riverside square with colorful houses'
          },
          {
            name: 'Dom Luís I Bridge',
            duration: '20 min',
            highlight: 'Iconic double-deck iron bridge designed by a student of Eiffel'
          }
        ]
      },
      {
        time: '12:30',
        title: 'Riverside Lunch',
        description: 'Enjoy a delicious lunch at a carefully selected local restaurant with stunning views of the Douro River. Savor traditional Portuguese dishes like francesinha (Porto\'s famous sandwich) and fresh seafood, paired with excellent local wines.',
        pois: [
          {
            name: 'Riverside Restaurant',
            duration: '1.5 hours',
            highlight: 'Authentic Portuguese cuisine with river views'
          }
        ]
      },
      {
        time: '14:30',
        title: 'Port Wine Cellar Experience',
        description: 'Cross the river to Vila Nova de Gaia for an exclusive private tour and tasting at one of the most prestigious Port wine cellars. Learn about the history of Port wine production and enjoy a premium tasting of different varieties.',
        pois: [
          {
            name: 'Premium Port Wine Cellar',
            duration: '1.5 hours',
            highlight: 'Private tour and tasting of premium Port wines'
          }
        ]
      },
      {
        time: '16:30',
        title: 'Douro River Cruise',
        description: 'Relax on a scenic 1-hour cruise along the Douro River, passing under six bridges while sipping on a welcome drink. Marvel at the city\'s skyline and learn about the river\'s importance to Porto\'s history and wine trade.',
        pois: [
          {
            name: 'Douro River Cruise',
            duration: '1 hour',
            highlight: 'Scenic cruise with stunning views of Porto\'s bridges'
          }
        ]
      },
      {
        time: '17:45',
        title: 'Drop-off & Farewell',
        description: 'Your guide will take you back to your hotel or drop you at a recommended location for dinner, with personalized recommendations for the rest of your stay in Porto.'
      }
    ],
    includes: [
      'Private professional guide (fluent in English, Spanish, or Portuguese)',
      'Hotel pickup and drop-off in central Porto',
      'Skip-the-line tickets to Livraria Lello',
      'Entrance to Clérigos Tower',
      'Private tour and premium tasting at a Port wine cellar',
      '1-hour Douro River cruise with welcome drink',
      'Private transportation in a comfortable, air-conditioned vehicle',
      'Bottled water and Wi-Fi in the vehicle',
      'All taxes and fees'
    ],
    excludes: [
      'Lunch (budget approximately €25-35 per person)',
      'Personal expenses',
      'Gratuities (optional)'
    ],
    meetingPoint: 'Your hotel or accommodation in central Porto',
    cancellationPolicy: 'Free cancellation up to 48 hours before the tour for a full refund. No-shows or cancellations within 48 hours will be charged the full price.',
    additionalInfo: [
      'This tour involves moderate walking, comfortable shoes are recommended',
      'The tour operates in all weather conditions, please dress appropriately',
      'Minimum drinking age is 18 years',
      'Infant seats available upon request',
      'Private tour - only your group will participate'
    ]
  },

  // SINTRA PRIVATE TOUR
  sintra: {
    id: 'sintra-premium',
    city: 'Sintra',
    label: 'Premium Sintra & Pena Palace Tour',
    duration: '8 hours',
    price: 'From €320',
    groupSize: '2-6 people',
    rating: 4.9,
    reviewCount: 156,
    category: 'Cultural Experience',
    description: 'Experience the magic of Sintra, a UNESCO World Heritage site, with our exclusive full-day private tour. Visit the colorful Pena Palace, the mysterious Quinta da Regaleira, and other fairytale castles with skip-the-line access and expert local guide.',
    highlights: [
      'Skip-the-line access to Pena Palace and Park',
      'Explore the mystical Quinta da Regaleira',
      'Visit the romantic Monserrate Palace',
      'Enjoy breathtaking views from the Moorish Castle',
      'Personalized attention from your private guide',
      'Comfortable transportation throughout the day'
    ],
    detailedItinerary: [
      {
        time: '09:00',
        title: 'Hotel Pickup & Journey to Sintra',
        description: 'Your private guide will meet you at your Lisbon hotel for a comfortable 40-minute drive to Sintra, a UNESCO-listed town known for its 19th-century Romantic architecture.',
        pois: [
          {
            name: 'Scenic Drive to Sintra',
            duration: '40 min',
            highlight: 'Enjoy beautiful coastal and mountain views on the way to Sintra'
          }
        ]
      },
      {
        time: '09:45',
        title: 'Pena Palace & Park',
        description: 'Begin your day at the colorful Pena Palace, a masterpiece of Romanticism and one of Portugal\'s most iconic landmarks. Explore the palace\'s extravagant interiors and the surrounding park with its exotic plants and hidden pathways.',
        pois: [
          {
            name: 'Pena Palace',
            duration: '2 hours',
            highlight: 'UNESCO World Heritage Site with stunning architecture and panoramic views'
          }
        ]
      },
      {
        time: '12:00',
        title: 'Traditional Portuguese Lunch',
        description: 'Enjoy a delicious lunch at a carefully selected local restaurant in Sintra, featuring traditional Portuguese cuisine and local wines.',
        pois: [
          {
            name: 'Local Restaurant in Sintra',
            duration: '1 hour',
            highlight: 'Authentic Portuguese dishes in a charming setting'
          }
        ]
      },
      {
        time: '13:30',
        title: 'Quinta da Regaleira',
        description: 'Discover the mysterious Quinta da Regaleira, a UNESCO-listed estate with its enchanting gardens, underground tunnels, and the famous Initiation Well.',
        pois: [
          {
            name: 'Quinta da Regaleira',
            duration: '1.5 hours',
            highlight: 'Mystical gardens and the famous Initiation Well'
          }
        ]
      },
      {
        time: '15:30',
        title: 'Moorish Castle',
        description: 'Visit the ancient Moorish Castle for breathtaking panoramic views of Sintra, the Pena Palace, and the Atlantic Ocean.',
        pois: [
          {
            name: 'Moorish Castle',
            duration: '45 min',
            highlight: 'Historic fortress with stunning views over Sintra'
          }
        ]
      },
      {
        time: '16:30',
        title: 'Return to Lisbon',
        description: 'Relax on your comfortable journey back to your hotel in Lisbon, with wonderful memories of your day in magical Sintra.',
        pois: [
          {
            name: 'Return Journey',
            duration: '40 min',
            highlight: 'Comfortable return to your Lisbon hotel'
          }
        ]
      }
    ],
    includes: [
      'Private professional guide',
      'Hotel pickup and drop-off in Lisbon',
      'Skip-the-line tickets to Pena Palace and Quinta da Regaleira',
      'Private vehicle with air conditioning',
      'Bottled water in the vehicle',
      'All taxes, fees and handling charges'
    ],
    excludes: [
      'Lunch (budget approximately €25-35 per person)',
      'Personal expenses',
      'Gratuities (optional)'
    ],
    meetingPoint: 'Your hotel in Lisbon',
    cancellationPolicy: 'Free cancellation up to 48 hours before the tour for a full refund. No-shows or cancellations within 48 hours will be charged the full price.',
    additionalInfo: [
      'This tour involves moderate walking, comfortable shoes are recommended',
      'The tour operates in all weather conditions, please dress appropriately',
      'Infant seats available upon request',
      'Most travelers can participate',
      'Private tour - only your group will participate'
    ]
  },

  // DOURO VALLEY PRIVATE TOUR
  douro: {
    id: 'douro-premium',
    city: 'Douro',
    label: 'Premium Douro Valley Wine Experience',
    duration: '10 hours',
    price: 'From €350',
    groupSize: '2-6 people',
    rating: 4.9,
    reviewCount: 218,
    category: 'Wine Tasting & Scenic Tour',
    description: 'Immerse yourself in the breathtaking landscapes of the Douro Valley, a UNESCO World Heritage site, with our exclusive full-day private wine tour. Visit prestigious wineries, enjoy wine tastings, and cruise along the Douro River while learning about Portugal\'s winemaking traditions from your expert guide.',
    highlights: [
      'Wine tastings at two premium Quintas (wine estates)',
      'Scenic boat cruise on the Douro River',
      'Traditional Portuguese lunch with local wines',
      'Visit to the charming town of Pinhão',
      'Panoramic views of the Douro Valley terraces',
      'Personalized attention from your private guide'
    ],
    detailedItinerary: [
      {
        time: '08:00',
        title: 'Hotel Pickup',
        description: 'Your private guide will meet you at your accommodation in Porto for the scenic drive to the Douro Valley.',
        pois: [
          {
            name: 'Scenic Drive to Douro',
            duration: '1.5 hours',
            highlight: 'Enjoy beautiful views of the Portuguese countryside'
          }
        ]
      },
      {
        time: '09:30',
        title: 'First Winery Visit',
        description: 'Visit a family-owned Quinta for a guided tour of the vineyards and cellars, followed by a tasting of their premium Port and Douro wines.',
        pois: [
          {
            name: 'Winery Tour & Tasting',
            duration: '1.5 hours',
            highlight: 'Learn about traditional winemaking methods and taste exceptional wines'
          }
        ]
      },
      {
        time: '11:30',
        title: 'Douro River Cruise',
        description: 'Enjoy a relaxing 1-hour boat cruise along the Douro River, taking in the stunning terraced vineyards and quintas that line the riverbanks.',
        pois: [
          {
            name: 'Scenic River Cruise',
            duration: '1 hour',
            highlight: 'Breathtaking views of the Douro Valley from the water'
          }
        ]
      },
      {
        time: '12:30',
        title: 'Traditional Lunch',
        description: 'Savor a delicious traditional Portuguese lunch at a local restaurant, paired with excellent Douro wines.',
        pois: [
          {
            name: 'Local Restaurant',
            duration: '1.5 hours',
            highlight: 'Authentic Portuguese cuisine with stunning valley views'
          }
        ]
      },
      {
        time: '14:00',
        title: 'Second Winery Visit',
        description: 'Visit a second prestigious Quinta for another wine tasting experience, focusing on their premium Port wines.',
        pois: [
          {
            name: 'Port Wine Tasting',
            duration: '1 hour',
            highlight: 'Sample award-winning Port wines in a stunning setting'
          }
        ]
      },
      {
        time: '15:30',
        title: 'Pinhão Village',
        description: 'Explore the charming riverside village of Pinhão, known for its beautiful train station with traditional azulejo tiles.',
        pois: [
          {
            name: 'Pinhão Village',
            duration: '30 min',
            highlight: 'Visit the famous train station with its beautiful tile panels'
          }
        ]
      },
      {
        time: '16:30',
        title: 'Return to Porto',
        description: 'Relax on the scenic drive back to Porto, with a stop at a panoramic viewpoint for one last look at the magnificent Douro Valley.',
        pois: [
          {
            name: 'Return Journey',
            duration: '1.5 hours',
            highlight: 'Comfortable return to your Porto hotel'
          }
        ]
      }
    ],
    includes: [
      'Private professional guide',
      'Hotel pickup and drop-off in Porto',
      'Wine tastings at two premium Quintas',
      '1-hour Douro River cruise',
      'Traditional Portuguese lunch with wine',
      'Private vehicle with air conditioning',
      'Bottled water in the vehicle',
      'All taxes, fees and handling charges'
    ],
    excludes: [
      'Additional food and drinks',
      'Personal expenses',
      'Gratuities (optional)'
    ],
    meetingPoint: 'Your hotel in Porto',
    cancellationPolicy: 'Free cancellation up to 48 hours before the tour for a full refund. No-shows or cancellations within 48 hours will be charged the full price.',
    additionalInfo: [
      'Minimum drinking age is 18 years',
      'Comfortable walking shoes are recommended',
      'The tour operates in all weather conditions, please dress appropriately',
      'Infant seats available upon request',
      'Private tour - only your group will participate'
    ]
  },

  // Algarve Private Tour
  algarve: {
    id: 'algarve-private',
    city: 'Algarve',
    label: 'Private Algarve Coastal Tour',
    duration: '8 hours',
    price: 'From €270',
    groupSize: '1-6 people',
    description: 'Discover the stunning coastline of the Algarve, including dramatic cliffs, hidden beaches, and charming fishing villages.',
    highlights: [
      'Visit to Ponta da Piedade',
      'Benagil Cave boat tour (seasonal)',
      'Lagos and Carvoeiro villages',
      'Scenic coastal walks',
      'Hotel pickup and drop-off'
    ],
    itinerary: [
      {
        time: '09:00',
        title: 'Hotel Pickup',
        description: 'Meet your private guide at your hotel in the Algarve.'
      },
      {
        time: '09:30-12:30',
        title: 'Western Algarve',
        description: 'Visit Ponta da Piedade and explore the stunning coastal scenery.'
      },
      {
        time: '12:30-14:00',
        title: 'Seafood Lunch',
        description: 'Dine on fresh seafood at a local restaurant.'
      },
      {
        time: '14:00-17:00',
        title: 'Coastal Villages',
        description: 'Explore the charming villages of Lagos and Carvoeiro.'
      },
      {
        time: '17:00',
        title: 'Drop-off',
        description: 'Return to your hotel in the Algarve.'
      }
    ],
    includes: [
      'Private professional guide',
      'Hotel pickup and drop-off',
      'All transportation during the tour',
      'Bottled water in the vehicle'
    ],
    excludes: [
      'Meals and drinks',
      'Boat tour tickets',
      'Personal expenses',
      'Gratuities (optional)'
    ],
    meetingPoint: 'Your hotel in the Algarve',
    cancellationPolicy: 'Free cancellation up to 24 hours before the tour',
    additionalInfo: [
      'Comfortable walking shoes recommended',
      'Swimwear and towel recommended in summer',
      'Sunscreen and hat recommended'
    ]
  }
};
